import React, { Component } from 'react';
import ReactGA from 'react-ga';
import { Link } from 'react-router-dom'

import magazine from '../../images/arts-and-culture/magazine.png';
import layouts from '../../images/arts-and-culture/layouts.png';


class ArtsAndCulture extends Component {
  render() {
    ReactGA.initialize('UA-68424037-1');
    return (

      <div className="grid">
        <div className="grid-item-wide">
          <div className="element">
            <h1 className="title">The Conversation —<br />Arts + Culture redesign</h1>
          </div>
        </div>

        <div className="grid-item">
          <div className="element">
            <p>
              <strong>The Conversation</strong> is an independent source of news and views, sourced from the academic and research community and delivered direct to the public.
            </p>

            <p>
              As part of launching the Arts &amp; Culture section, a new weekend-magazine style layout was needed.
            </p>
          </div>
        </div>

        <div className="grid-item-padded grid-item grid-item-wide">
          <img src={ magazine } alt="Magazine" />
        </div>

        <div className="grid-item five-grid-item-prepend-two four-grid-item-prepend-one three-grid-item-prepend-one">
          <div className="element">
            <p>
              It was the first departure design-wise from the standard page layouts for every section; the Arts &amp; Culture section could, with it's tendency to have the biggest, flashiest lead images, should have the images at the fore.
            </p>

            <p>
              Therefore, it needed to have the flexibility to show that off; a customisable grid to allow a combination of layouts.
            </p>
          </div>
        </div>

        <div className="grid-item">
          <div className="element">
            <p>
              From the large ‘bull’ image (a four by two unit image) dominating the layout if an article's image was suitable, down to four 1x1 articles, it had to handle a different layout each news day.
            </p>

            <img src={ layouts } alt="Layouts"/>
          </div>
        </div>

        <div className="grid-item three-grid-item-prepend-two two-grid-item-prepend-one">
          <div className="element">
            <p>
              Since launch, it's been adopted by the <Link to="http://www.theconversation.com/uk/arts" target="_blank">UK</Link> and <Link to="http://www.theconversation.com/us/arts" target="_blank">US</Link> editions as well.
            </p>

            <p>
              To see this in action, please read <Link to="http://www.theconversation.com/au/arts" target="_blank">The Conversation Arts &amp; Culture</Link> section.
            </p>
          </div>
        </div>
      </div>
    );
  }
}

export default ArtsAndCulture;




// WEBPACK FOOTER //
// ./src/pages/ArtsAndCulture/index.js